// Unified mapper for employee update operations
import type { EmployeeProfile, LC_UpdateEmployeeIn } from '../types';

/**
 * Helper to convert yyyy-mm-dd (DatePicker format) to ISO datetime for backend
 */
const formatISODateToBackendDateTime = (dateString: string | null): string | null => {
  if (!dateString) return null;
  const parts = dateString.split('-');
  if (parts.length !== 3) return null;
  const [year, month, day] = parts;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (isNaN(date.getTime())) return null;
  return date.toISOString();
};

/**
 * Maps EmployeeProfile domain model to unified update request
 * Includes ALL fields from all tabs (personal, contact, address)
 */
export function mapEmployeeProfileToUpdateRequest(
  profile: EmployeeProfile,
): LC_UpdateEmployeeIn {
  return {
    employeeId: profile.id,
    // Personal data
    firstNames: profile.firstNames,
    lastName: profile.lastName,
    secondLastName: profile.secondLastName || null,
    birthDate: formatISODateToBackendDateTime(profile.birthDate) || '',
    genderCode: profile.genderCode || 'M',
    maritalStatusId: profile.maritalStatusId || 0,
    employmentStatus: profile.employmentStatus || 'V',
    // Contact data
    corporateEmail: profile.corporateEmail || '',
    personalEmail: profile.personalEmail || '',
    personalPhoneNumber: profile.personalPhoneNumber || null,
    companyPhoneNumber: profile.companyPhoneNumber || null,
    // Address data
    address: profile.address || null,
    regionId: profile.regionId,
    communeId: profile.communeId,
    workAddress: profile.workAddress || null,
    workRegionId: profile.workRegionId,
    workCommuneId: profile.workCommuneId,
    doesNotSync: profile.doesNotSync,
  };
}
